(function () {
  function initializeResponsiveHeroVideos() {
    var videos = document.querySelectorAll('video.sa-responsive-hero-video[data-desktop-src]:not([data-sa-video-initialized])');
    var mobileViewport = window.matchMedia('(max-width: 767px)').matches;
    videos.forEach(function (video) {
      video.setAttribute('data-sa-video-initialized', 'true');
      if (video.dataset.autoplay !== 'true') return;

      var fullSourceUrl = mobileViewport ? video.dataset.mobileSrc : video.dataset.desktopSrc;
      var introSourceUrl = window.saHeroIntroSource || (
        video.canPlayType('video/webm; codecs="av01.0.05M.08"') !== ''
          ? video.dataset.introAv1Src
          : video.dataset.introSrc
      );
      var introOffset = 0;
      if (!fullSourceUrl || !introSourceUrl) return;

      var fullVideoRequested = false;
      var introComplete = false;
      var frame = video.parentElement.querySelector('.sa-hero-video-canvas');
      var frameContext = frame && frame.getContext('2d', { alpha: false });
      var animationFrame = 0;

      function resizeFrame() {
        if (!frame || !video.videoWidth || !video.videoHeight) return;
        var rect = frame.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        var scale = Math.min(window.devicePixelRatio || 1, video.videoWidth / rect.width, video.videoHeight / rect.height);
        frame.width = Math.max(1, Math.round(rect.width * scale));
        frame.height = Math.max(1, Math.round(rect.height * scale));
      }

      function paintFrame() {
        if (!frameContext || !frame) return;
        if (video.readyState >= 2 && video.videoWidth && video.videoHeight) {
          if (!frame.width || !frame.height) resizeFrame();
          var sourceAspect = video.videoWidth / video.videoHeight;
          var targetAspect = frame.width / frame.height;
          var sourceX = 0;
          var sourceY = 0;
          var sourceWidth = video.videoWidth;
          var sourceHeight = video.videoHeight;

          if (sourceAspect > targetAspect) {
            sourceWidth = video.videoHeight * targetAspect;
            sourceX = (video.videoWidth - sourceWidth) / 2;
          } else {
            sourceHeight = video.videoWidth / targetAspect;
            sourceY = (video.videoHeight - sourceHeight) / 2;
          }

          frameContext.drawImage(video, sourceX, sourceY, sourceWidth, sourceHeight, 0, 0, frame.width, frame.height);
          video.parentElement.classList.add('sa-video-frame-ready');
          document.documentElement.classList.add('sa-video-frame-ready');
        }
      }

      function drawFrame() {
        if (video.paused || video.ended) return;
        paintFrame();
        animationFrame = window.requestAnimationFrame(drawFrame);
      }

      function prepareIntroVideo() {
        if (video.src) return;
        video.addEventListener('loadeddata', function () {
          resizeFrame();
          paintFrame();
        }, { once: true });
        video.preload = 'auto';
        video.src = introSourceUrl;
        video.load();
      }

      function loadAndPlayVideo() {
        if (introComplete && !fullVideoRequested) return;
        if (!video.src) {
          video.src = introSourceUrl;
          video.load();
        }
        var playPromise = video.play();
        if (playPromise) playPromise.catch(function () {});
      }

      function upgradeToFullVideo() {
        if (fullVideoRequested) {
          loadAndPlayVideo();
          return;
        }
        fullVideoRequested = true;
        var resumeTime = introOffset + (video.currentTime || 0.5);
        // Keep the final intro frame on the canvas while the full source buffers.
        // The new source replaces it only after a valid decoded frame is ready.
        video.src = fullSourceUrl;
        video.loop = true;
        video.load();
        video.addEventListener('loadedmetadata', function () {
          video.currentTime = Math.min(resumeTime, Math.max(0, video.duration - 0.1));
          var playPromise = video.play();
          if (playPromise) playPromise.catch(function () {});
        }, { once: true });
      }

      video.addEventListener('playing', function () {
        video.classList.add('is-playing');
        window.cancelAnimationFrame(animationFrame);
        resizeFrame();
        drawFrame();
      });

      video.addEventListener('ended', function () {
        if (!fullVideoRequested) introComplete = true;
      });

      video.addEventListener('error', function () {
        video.classList.remove('is-playing');
        video.parentElement.classList.remove('sa-video-frame-ready');
        document.documentElement.classList.remove('sa-video-frame-ready');
      });

      video.addEventListener('pause', function () {
        window.cancelAnimationFrame(animationFrame);
      });

      if ('ResizeObserver' in window && frame) {
        new window.ResizeObserver(resizeFrame).observe(frame);
      }

      prepareIntroVideo();

      var autoStartReady = false;
      var autoStartTimer = 0;
      var isNearViewport = true;

      function queueAutoStart() {
        if (autoStartTimer) return;
        var elapsed = window.performance && typeof window.performance.now === 'function' ? window.performance.now() : 0;
        var remainingDelay = Math.max(0, 2000 - elapsed);
        autoStartTimer = window.setTimeout(function () {
          autoStartReady = true;
          if (isNearViewport) loadAndPlayVideo();
        }, remainingDelay);
      }

      queueAutoStart();

      if ('IntersectionObserver' in window) {
        var observer = new window.IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            isNearViewport = entry.isIntersecting;
            if (entry.isIntersecting && autoStartReady) {
              loadAndPlayVideo();
            } else if (!entry.isIntersecting) {
              video.pause();
            }
          });
        }, { rootMargin: '200px 0px', threshold: 0.05 });
        observer.observe(video);
      }

      function continueWithFullVideo(event) {
        if (!event.isTrusted) return;
        upgradeToFullVideo();
      }

      ['pointerdown', 'touchstart', 'keydown', 'wheel'].forEach(function (eventName) {
        window.addEventListener(eventName, continueWithFullVideo, { once: true, capture: true, passive: true });
      });

    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeResponsiveHeroVideos, { once: true });
  } else {
    initializeResponsiveHeroVideos();
  }

  document.addEventListener('shopify:section:load', initializeResponsiveHeroVideos);
}());
